<form [formGroup]="threadGroupForm" class="m-3">
    <div class="row">
        <div>
            <button style="margin: 5px;" class="btn btn-primary btn-sm" type="button" (click)="updateData('rate(1/min)')">rate(1/min)</button>
            <button style="margin: 5px;" class="btn btn-primary btn-sm" type="button" (click)="updateData('random_arrivals(10min)')">random_arrivals(10 min)</button>
            <button style="margin: 5px;" class="btn btn-primary btn-sm" type="button" (click)="updateData('pause(1min)')">pause(1 min)</button>
            <button style="margin: 5px;" class="btn btn-primary btn-sm" type="button" (click)="updateData('/*comment*/')">/* comment */</button>
        </div>
    </div>
    <div class="row">
        <div style="width: 100%;">
            <label for=""> Input : </label>
            <textarea style="margin: 5px;" name="comment" formControlName="schedule" class="form-control" rows="2" cols="80" required></textarea>
        </div>
    </div>
    <div *ngIf="errorDiv">
        <div class="text-danger"> Input Schedule cannot be empty. </div>
    </div>
</form>
<div class="modal-footer" style="border-top: none;">
    <button type="submit" class="btn btn-primary btn-sm" (click)="saveConfiguration()" *ngIf="!edited"> Add Configuration </button>
    <button type="submit" class="btn btn-primary btn-sm" (click)="updateConfiguration()" *ngIf="edited"> Update Configuration </button>
    <button class="btn btn-warning btn-sm" type="button" (click)="cancelThreadGroupCreation()">Cancel</button>
</div>